import { useState, useEffect } from 'react'

import { lazyRemoteModule } from '@space-shell/lib/runtime'
import { Route, Routes } from 'react-router-dom'

type Route = {
  path: string
  component: React.ComponentType
  index?: boolean
}

export const CommunityRoutes = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [communityRoutes, setCommunityRoutes] = useState<Route[]>([])

  useEffect(() => {
    async function importRoutes() {
      try {
        const remoteRoutes = await lazyRemoteModule<Route[]>('community/routes')

        if (remoteRoutes) {
          setCommunityRoutes(remoteRoutes)
        }
      } finally {
        setIsLoading(false)
      }
    }

    importRoutes()
  }, [])

  if (isLoading) {
    return null
  }

  return (
    <Routes>
      {communityRoutes.map(({ path, index, component: Component }) => (
        <Route key={path} index={index} path={index ? undefined : path} element={<Component />} />
      ))}
    </Routes>
  )
}
